import { render, staticRenderFns } from "./TheModalMedicalIndication.vue?vue&type=template&id=1a51ba4e&"
import script from "./TheModalMedicalIndication.vue?vue&type=script&lang=js&"
export * from "./TheModalMedicalIndication.vue?vue&type=script&lang=js&"
import style0 from "./TheModalMedicalIndication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports